import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`I am pursuing my final year in Computer Science & Engineering at Dayananda Sagar University.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`I am very much passionate about programming. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`My ingredients for developing a software application are innovation and dedication.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`I have a creative touch to me, and I always use it to think out-of-the-box.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`I like to play my artistic card and develop software applications with Passion and Elegance.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      